<template>
<div class="input-text-size">
 <v-row dense>
          <v-col cols="3">
            <span>Tax Year:</span>
          </v-col>
          <v-col cols="4">
            <v-text-field
              class="mt-n2 ml-n4"
              dense
              hide-details
              v-model.number="editedItem.taxYear"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="3">
            <span>Tax ID:</span>
          </v-col>
          <v-col cols="4">
            <v-text-field
              class="mt-n2 ml-n4"
              dense
              hide-details
              v-model.number="editedItem.taxId"
            ></v-text-field>
          </v-col>
        </v-row>
</div>

</template>
<script>
import {
  mapGetters,
} from 'vuex';
import '../../../assets/style.css';

export default {
  data() {
    return {

    };
  },
  props: {
    baseCrudKey: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapGetters('base/crud', [
      'item',
      'items',
      'index',
      'isVisible',
    ]),
    ...mapGetters(['todaysDate']),

    editedItem: {
      get() {
        return this.item(this.baseCrudKey);
      },
      set(value) {
        this.setItem([this.baseCrudKey, value]);
      },
    },
  },
  methods: {
  },
};
</script>
